import { createSlice } from '@reduxjs/toolkit'
import {
  getMissions,
  getMissionbyId,
  deleteMission,
  addMission,
  updateMission,
  Search,
  getProjectPriorityCriticalHighRatio,
  getProjectPriorityHighRatio,
  getProjectPriorityCriticalRatio,
  getprojetCountsByPriority,
  getProjectCountsByPriorityAndStatus,
  getProjectsBudgetTable,
  CalculateProjectTypeBudgetRatios,
  CalculateCriticalCompletedProjectsRatio,
  CalculateOverdueProjectRatio,
  CountIncidentsCriticalOrHighRatioByMission,
  CountIncidentsByTypeForMission,
  CountIncidentsWithSlaUnder24Ratio,
  CountIncidentsWithPerimeterNetworkRatio,
  CountIncidentsWithPerimeterServer,
  CountCriticalNetworkIncidentsRatio,
  CountAppRelatedIncidentsRatio,
  getProjectCountsByTypeAndStatus,
  calculateCriticalBudgetRatioByMissionId,
  CriticalServerIncidentsRatio,
  countCriticalApplicationIncidentsRatio,
  countCriticalPcIncidentsRatio,
  countCriticalDMZIncidentsRatio,
  GetVulnerabilityDistributionByMissionId,
  fetchActionPriorityCriticalRatio,
  fetchActionPriorityHighRatio,
  fetchActionPriorityMediumRatio,
  fetchActionPriorityLowRatio,
  fetchCriticalActionsByMissionId,
  fetchHighActionsByMissionId,
  fetchMediumActionsByMissionId,
  fetchLowActionsByMissionId,
} from './missionActions'
import {
  ActionPriorityRatio,
  ActionsByMission,
  calculateCriticalBudgetRatio,
  calculateCriticalCompletedProjectsRatio,
  calculateOverdueProjectRatio,
  calculateProjectTypeBudgetRatios,
  countAppRelatedIncidentsRatio,
  countCriticalApplicationIncidentsRatioType,
  countCriticalDMZIncidentsRatioType,
  countCriticalNetworkIncidentsRatio,
  countCriticalPcIncidentsRatioType,
  countIncidentsByTypeForMission,
  countIncidentsCriticalOrHighRatioByMission,
  countIncidentsWithPerimeterNetworkRatio,
  countIncidentsWithPerimeterServerRatio,
  countIncidentsWithSlaUnder24Ratio,
  countProject,
  CriticalServerIncidentsRatioType,
  Mission,
  MissionResponse,
  ProjectCountsByPriorityAndStatus,
  projectCountsByTypeAndStatus,
  projectPriorityCriticalRatio,
  projectPriorityHighRatio,
  ProjectsBudgetTable,
  projetCountsByPriority,
  VulnerabilityDistribution,
} from '../../types/missionTypes'

interface MissionState {
  missions: Mission[]
  loading: boolean
  mission: Mission | null
  error: string | null
  addedMission: Mission | null
  updatedMission: Mission | null
  MissionResponse: MissionResponse | null
  status?: number
  message?: string
  projectPriorityCriticalRatio: projectPriorityCriticalRatio | null
  projectPriorityHighRatio: projectPriorityHighRatio | null
  countProject: countProject | null
  ProjectCountsByPriorityAndStatus: ProjectCountsByPriorityAndStatus | null
  ProjectsBudgetTable: ProjectsBudgetTable | null
  calculateCriticalBudgetRatio: calculateCriticalBudgetRatio | null
  calculateProjectTypeBudgetRatios: calculateProjectTypeBudgetRatios | null
  calculateCriticalCompletedProjectsRatio: calculateCriticalCompletedProjectsRatio | null
  calculateOverdueProjectRatio: calculateOverdueProjectRatio | null
  countIncidentsCriticalOrHighRatioByMission: countIncidentsCriticalOrHighRatioByMission | null
  countIncidentsByTypeForMission: countIncidentsByTypeForMission | null
  countIncidentsWithSlaUnder24Ratio: countIncidentsWithSlaUnder24Ratio | null
  countIncidentsWithPerimeterNetworkRatio: countIncidentsWithPerimeterNetworkRatio | null
  countIncidentsWithPerimeterServerRatio: countIncidentsWithPerimeterServerRatio | null
  countCriticalServerIncidentsRatio: CriticalServerIncidentsRatioType | null

  countCriticalNetworkIncidentsRatio: countCriticalNetworkIncidentsRatio | null
  countAppRelatedIncidentsRatio: countAppRelatedIncidentsRatio | null
  projetCountsByPriority: projetCountsByPriority | null
  projectCountsByTypeAndStatus: projectCountsByTypeAndStatus | null
  countCriticalApplicationRatio: countCriticalApplicationIncidentsRatioType | null
  CriticalPcIncidentsRatio: countCriticalPcIncidentsRatioType | null
  CriticalDMZIncidentsRatio: countCriticalDMZIncidentsRatioType | null
  vulnerabilityDistribution: VulnerabilityDistribution | null
  critical?: ActionPriorityRatio
  high?: ActionPriorityRatio
  medium?: ActionPriorityRatio
  low?: ActionPriorityRatio
  criticalActions?: ActionsByMission
  highActions?: ActionsByMission
  mediumAction?: ActionsByMission
  lowActions?: ActionsByMission
}

const initialState: MissionState = {
  missions: [],
  loading: false,
  error: null,
  addedMission: null,
  mission: null,
  updatedMission: null,
  MissionResponse: null,
  status: undefined,
  message: undefined,
  projectPriorityCriticalRatio: null,
  projectPriorityHighRatio: null,
  countProject: null,
  ProjectCountsByPriorityAndStatus: null,
  ProjectsBudgetTable: null,
  calculateCriticalBudgetRatio: null,
  calculateProjectTypeBudgetRatios: null,
  calculateCriticalCompletedProjectsRatio: null,
  calculateOverdueProjectRatio: null,
  countIncidentsCriticalOrHighRatioByMission: null,
  countIncidentsByTypeForMission: null,
  countIncidentsWithSlaUnder24Ratio: null,
  countIncidentsWithPerimeterNetworkRatio: null,
  countIncidentsWithPerimeterServerRatio: null,
  countCriticalNetworkIncidentsRatio: null,
  countCriticalServerIncidentsRatio: null,
  countAppRelatedIncidentsRatio: null,
  projetCountsByPriority: null,
  projectCountsByTypeAndStatus: null,
  countCriticalApplicationRatio: null,
  CriticalPcIncidentsRatio: null,
  CriticalDMZIncidentsRatio: null,
  vulnerabilityDistribution: null,
}

export const missionSlice = createSlice({
  name: 'mission',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getMissions.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getMissions.fulfilled, (state, action) => {
        state.loading = false
        state.MissionResponse = {
          missions: action.payload.missions,
          totalPages: action.payload.totalPages,
          total: action.payload.total,
          status: action.payload.status,
          message: action.payload.message,
        }
      })
      .addCase(getMissions.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })

      .addCase(Search.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(Search.fulfilled, (state, action) => {
        state.loading = false
        state.missions = action.payload
      })
      .addCase(Search.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })
      .addCase(deleteMission.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(deleteMission.fulfilled, (state, action) => {
        state.loading = false
        const deletedMissionId = action.meta.arg

        if (state.MissionResponse) {
          state.MissionResponse.missions = (
            state.MissionResponse.missions ?? []
          ).filter((mission) => mission._id !== deletedMissionId)

          state.MissionResponse.total = state.MissionResponse.total ?? 0
          state.MissionResponse.totalPages =
            state.MissionResponse.totalPages ?? 0
          state.MissionResponse.currentPage =
            state.MissionResponse.currentPage ?? 0
        }
      })

      .addCase(deleteMission.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })
      .addCase(addMission.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(addMission.fulfilled, (state, action) => {
        state.loading = false
        state.addedMission = action.payload
      })
      .addCase(addMission.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })
      .addCase(getMissionbyId.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getMissionbyId.fulfilled, (state, action) => {
        state.loading = false
        state.mission = action.payload
      })
      .addCase(getMissionbyId.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })
      .addCase(updateMission.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(updateMission.fulfilled, (state, action) => {
        state.loading = false
        state.updatedMission = action.payload
      })
      .addCase(updateMission.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })

      .addCase(getProjectPriorityCriticalHighRatio.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(
        getProjectPriorityCriticalHighRatio.fulfilled,
        (state, action) => {
          state.loading = false
          state.projectPriorityCriticalRatio = {
            ratio: action.payload.ratio ?? 0,
          }
        }
      )
      .addCase(
        getProjectPriorityCriticalHighRatio.rejected,
        (state, action) => {
          state.loading = false
          state.error = action.error.message || 'Something went wrong'
        }
      )

      .addCase(getProjectPriorityHighRatio.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getProjectPriorityHighRatio.fulfilled, (state, action) => {
        state.loading = false
        state.projectPriorityHighRatio = {
          ratio: action.payload.ratio ?? 0,
        }
      })
      .addCase(getProjectPriorityHighRatio.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })

      .addCase(getProjectPriorityCriticalRatio.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getProjectPriorityCriticalRatio.fulfilled, (state, action) => {
        state.loading = false
        state.projectPriorityHighRatio = {
          ratio: action.payload.ratio ?? 0,
        }
      })
      .addCase(getProjectPriorityCriticalRatio.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })

      .addCase(getProjectCountsByPriorityAndStatus.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(
        getProjectCountsByPriorityAndStatus.fulfilled,
        (state, action) => {
          state.loading = false
          state.ProjectCountsByPriorityAndStatus = {
            status: action.payload.status,
            erreur: action.payload.erreur,
            message: action.payload.message,
            counts: {
              CRITICAL: {
                'En attente': action.payload.counts.CRITICAL['En attente'],
                'En cours': action.payload.counts.CRITICAL['En cours'],
                'A faire': action.payload.counts.CRITICAL['A faire'],
                Suspendu: action.payload.counts.CRITICAL['Suspendu'],
                Terminé: action.payload.counts.CRITICAL['Terminé'],
              },
              HIGH: {
                'En attente': action.payload.counts.HIGH['En attente'],
                'En cours': action.payload.counts.HIGH['En cours'],
                'A faire': action.payload.counts.HIGH['A faire'],
                Suspendu: action.payload.counts.HIGH['Suspendu'],
                Terminé: action.payload.counts.HIGH['Terminé'],
              },
              MEDIUM: {
                'En attente': action.payload.counts.MEDIUM['En attente'],
                'En cours': action.payload.counts.MEDIUM['En cours'],
                'A faire': action.payload.counts.MEDIUM['A faire'],
                Suspendu: action.payload.counts.MEDIUM['Suspendu'],
                Terminé: action.payload.counts.MEDIUM['Terminé'],
              },
              LOW: {
                'En attente': action.payload.counts.LOW['En attente'],
                'En cours': action.payload.counts.LOW['En cours'],
                'A faire': action.payload.counts.LOW['A faire'],
                Suspendu: action.payload.counts.LOW['Suspendu'],
                Terminé: action.payload.counts.LOW['Terminé'],
              },
            },
          }
        }
      )

      .addCase(
        getProjectCountsByPriorityAndStatus.rejected,
        (state, action) => {
          state.loading = false
          state.error = action.error.message || 'Something went wrong'
        }
      )

      .addCase(getProjectsBudgetTable.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getProjectsBudgetTable.fulfilled, (state, action) => {
        state.loading = false
        state.ProjectsBudgetTable = {
          erreur: action.payload.erreur,
          status: action.payload.status,
          message: action.payload.message,
          table: action.payload.table.map(
            (item: { name: string; budget: number }) => ({
              name: item.name,
              budget: item.budget,
            })
          ),
        }
      })
      .addCase(getProjectsBudgetTable.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })

      .addCase(calculateCriticalBudgetRatioByMissionId.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(
        calculateCriticalBudgetRatioByMissionId.fulfilled,
        (state, action) => {
          state.loading = false
          state.calculateCriticalBudgetRatio = {
            ratio: action.payload.ratio ?? 0,
          }
        }
      )
      .addCase(
        calculateCriticalBudgetRatioByMissionId.rejected,
        (state, action) => {
          state.loading = false
          state.error = action.error.message || 'Something went wrong'
        }
      )

      .addCase(CalculateProjectTypeBudgetRatios.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(CalculateProjectTypeBudgetRatios.fulfilled, (state, action) => {
        state.loading = false
        state.calculateProjectTypeBudgetRatios = {
          ratios: {
            'Gouvernance du SI': action.payload.ratios['Gouvernance du SI'],
            Opérationnel: action.payload.ratios.Opérationnel,
            'Gestion de la sécurité du SI':
              action.payload.ratios['Gestion de la sécurité du SI'],
          },
        }
      })
      .addCase(CalculateProjectTypeBudgetRatios.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })

      .addCase(CalculateCriticalCompletedProjectsRatio.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(
        CalculateCriticalCompletedProjectsRatio.fulfilled,
        (state, action) => {
          state.loading = false
          state.calculateCriticalCompletedProjectsRatio = {
            ratio: action.payload.ratio ?? 0,
          }
        }
      )
      .addCase(
        CalculateCriticalCompletedProjectsRatio.rejected,
        (state, action) => {
          state.loading = false
          state.error = action.error.message || 'Something went wrong'
        }
      )

      .addCase(CalculateOverdueProjectRatio.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(CalculateOverdueProjectRatio.fulfilled, (state, action) => {
        state.loading = false
        state.calculateOverdueProjectRatio = {
          ratio: action.payload.ratio ?? 0,
        }
      })
      .addCase(CalculateOverdueProjectRatio.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })

      .addCase(CountIncidentsCriticalOrHighRatioByMission.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(
        CountIncidentsCriticalOrHighRatioByMission.fulfilled,
        (state, action) => {
          state.loading = false
          state.countIncidentsCriticalOrHighRatioByMission = {
            ratio: action.payload.ratio ?? 0,
          }
        }
      )
      .addCase(
        CountIncidentsCriticalOrHighRatioByMission.rejected,
        (state, action) => {
          state.loading = false
          state.error = action.error.message || 'Something went wrong'
        }
      )

      .addCase(CountIncidentsByTypeForMission.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(CountIncidentsByTypeForMission.fulfilled, (state, action) => {
        state.loading = false
        state.countIncidentsByTypeForMission = {
          Corruption: action.payload.Corruption ?? 0,
          Compromission: action.payload.Compromission ?? 0,
          Intrusion: action.payload.Intrusion ?? 0,
          'Divulgation des données':
            action.payload['Divulgation des données'] ?? 0,
          'Déni de service': action.payload['Déni de service'] ?? 0,
          'Exécution de code à distance':
            action.payload['Exécution de code à distance'] ?? 0,
          // Add missing properties with default values
          erreur: action.payload.erreur ?? '',
          status: action.payload.status ?? '',
          message: action.payload.message ?? '',
        }
      })
      .addCase(CountIncidentsByTypeForMission.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })

      .addCase(CountIncidentsWithSlaUnder24Ratio.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(CountIncidentsWithSlaUnder24Ratio.fulfilled, (state, action) => {
        state.loading = false
        state.countIncidentsWithSlaUnder24Ratio = {
          ratio: action.payload.ratio ?? 0,
        }
      })
      .addCase(CountIncidentsWithSlaUnder24Ratio.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })

      .addCase(CountIncidentsWithPerimeterNetworkRatio.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(
        CountIncidentsWithPerimeterNetworkRatio.fulfilled,
        (state, action) => {
          state.loading = false
          state.countIncidentsWithPerimeterServerRatio = {
            ratio: action.payload.ratio ?? 0,
          }
        }
      )
      .addCase(
        CountIncidentsWithPerimeterNetworkRatio.rejected,
        (state, action) => {
          state.loading = false
          state.error = action.error.message || 'Something went wrong'
        }
      )

      .addCase(CountIncidentsWithPerimeterServer.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(CountIncidentsWithPerimeterServer.fulfilled, (state, action) => {
        state.loading = false
        state.countIncidentsWithPerimeterServerRatio = {
          ratio: action.payload.ratio ?? 0,
        }
      })
      .addCase(CountIncidentsWithPerimeterServer.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })

      .addCase(CountCriticalNetworkIncidentsRatio.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(
        CountCriticalNetworkIncidentsRatio.fulfilled,
        (state, action) => {
          state.loading = false
          state.countCriticalNetworkIncidentsRatio = {
            ratio: action.payload.ratio ?? 0,
          }
        }
      )
      .addCase(CountCriticalNetworkIncidentsRatio.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })

      .addCase(CriticalServerIncidentsRatio.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(CriticalServerIncidentsRatio.fulfilled, (state, action) => {
        state.loading = false
        state.countCriticalServerIncidentsRatio = {
          ratio: action.payload.ratio ?? 0,
        }
      })
      .addCase(CriticalServerIncidentsRatio.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })

      .addCase(countCriticalApplicationIncidentsRatio.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(
        countCriticalApplicationIncidentsRatio.fulfilled,
        (state, action) => {
          state.loading = false
          state.countCriticalApplicationRatio = {
            ratio: action.payload.ratio ?? 0,
          }
        }
      )
      .addCase(
        countCriticalApplicationIncidentsRatio.rejected,
        (state, action) => {
          state.loading = false
          state.error = action.error.message || 'Something went wrong'
        }
      )

      .addCase(countCriticalPcIncidentsRatio.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(countCriticalPcIncidentsRatio.fulfilled, (state, action) => {
        state.loading = false
        state.CriticalPcIncidentsRatio = {
          ratio: action.payload.ratio ?? 0,
        }
      })
      .addCase(countCriticalPcIncidentsRatio.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })
      .addCase(countCriticalDMZIncidentsRatio.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(countCriticalDMZIncidentsRatio.fulfilled, (state, action) => {
        state.loading = false
        state.CriticalDMZIncidentsRatio = {
          ratio: action.payload.ratio ?? 0,
        }
      })
      .addCase(countCriticalDMZIncidentsRatio.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })

      .addCase(CountAppRelatedIncidentsRatio.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(CountAppRelatedIncidentsRatio.fulfilled, (state, action) => {
        state.loading = false
        state.countAppRelatedIncidentsRatio = {
          ratio: action.payload.ratio ?? 0,
        }
      })
      .addCase(CountAppRelatedIncidentsRatio.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })
      .addCase(GetVulnerabilityDistributionByMissionId.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(
        GetVulnerabilityDistributionByMissionId.fulfilled,
        (state, action) => {
          state.loading = false
          state.vulnerabilityDistribution = action.payload
        }
      )
      .addCase(
        GetVulnerabilityDistributionByMissionId.rejected,
        (state, action) => {
          state.loading = false
          state.error = action.error.message || 'Something went wrong'
        }
      )
      .addCase(getprojetCountsByPriority.fulfilled, (state, action) => {
        state.loading = false
        state.projetCountsByPriority = {
          counts: {
            1: action.payload.counts[1] ?? 0,
            2: action.payload.counts[2] ?? 0,
            3: action.payload.counts[3] ?? 0,
            4: action.payload.counts[4] ?? 0,
          },
        }
      })
      .addCase(getprojetCountsByPriority.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })

      .addCase(getProjectCountsByTypeAndStatus.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(getProjectCountsByTypeAndStatus.fulfilled, (state, action) => {
        state.loading = false
        state.projectCountsByTypeAndStatus = {
          counts: {
            'Gouvernance du SI': {
              'En attente':
                action.payload.counts['Gouvernance du SI']['En attente'],
              'En cours':
                action.payload.counts['Gouvernance du SI']['En cours'],
              'A faire': action.payload.counts['Gouvernance du SI']['A faire'],
              Suspendu: action.payload.counts['Gouvernance du SI'].Suspendu,
              Terminé: action.payload.counts['Gouvernance du SI'].Terminé,
            },
            'Gestion de la sécurité du SI': {
              'En attente':
                action.payload.counts['Gestion de la sécurité du SI'][
                  'En attente'
                ],
              'En cours':
                action.payload.counts['Gestion de la sécurité du SI'][
                  'En cours'
                ],
              'A faire':
                action.payload.counts['Gestion de la sécurité du SI'][
                  'A faire'
                ],
              Suspendu:
                action.payload.counts['Gestion de la sécurité du SI'].Suspendu,
              Terminé:
                action.payload.counts['Gestion de la sécurité du SI'].Terminé,
            },
            'Organisationnel/Processus': {
              'En attente':
                action.payload.counts['Organisationnel/Processus'][
                  'En attente'
                ],
              'En cours':
                action.payload.counts['Organisationnel/Processus']['En cours'],
              'A faire':
                action.payload.counts['Organisationnel/Processus']['A faire'],
              Suspendu:
                action.payload.counts['Organisationnel/Processus'].Suspendu,
              Terminé:
                action.payload.counts['Organisationnel/Processus'].Terminé,
            },
            Opérationnel: {
              'En attente': action.payload.counts.Opérationnel['En attente'],
              'En cours': action.payload.counts.Opérationnel['En cours'],
              'A faire': action.payload.counts.Opérationnel['A faire'],
              Suspendu: action.payload.counts.Opérationnel.Suspendu,
              Terminé: action.payload.counts.Opérationnel.Terminé,
            },
            Physique: {
              'En attente': action.payload.counts.Physique['En attente'],
              'En cours': action.payload.counts.Physique['En cours'],
              'A faire': action.payload.counts.Physique['A faire'],
              Suspendu: action.payload.counts.Physique.Suspendu,
              Terminé: action.payload.counts.Physique.Terminé,
            },
            'IT/DSI': {
              'En attente': action.payload.counts['IT/DSI']['En attente'],
              'En cours': action.payload.counts['IT/DSI']['En cours'],
              'A faire': action.payload.counts['IT/DSI']['A faire'],
              Suspendu: action.payload.counts['IT/DSI'].Suspendu,
              Terminé: action.payload.counts['IT/DSI'].Terminé,
            },
            'IT/Métier': {
              'En attente': action.payload.counts['IT/Métier']['En attente'],
              'En cours': action.payload.counts['IT/Métier']['En cours'],
              'A faire': action.payload.counts['IT/Métier']['A faire'],
              Suspendu: action.payload.counts['IT/Métier'].Suspendu,
              Terminé: action.payload.counts['IT/Métier'].Terminé,
            },
            Autres: {
              'En attente': action.payload.counts.Autres['En attente'],
              'En cours': action.payload.counts.Autres['En cours'],
              'A faire': action.payload.counts.Autres['A faire'],
              Suspendu: action.payload.counts.Autres.Suspendu,
              Terminé: action.payload.counts.Autres.Terminé,
            },
          },
        }
      })
      .addCase(getProjectCountsByTypeAndStatus.rejected, (state, action) => {
        state.loading = false
        state.error = action.error.message || 'Something went wrong'
      })
      .addCase(fetchActionPriorityCriticalRatio.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchActionPriorityCriticalRatio.fulfilled, (state, action) => {
        state.loading = false
        state.critical = action.payload
      })
      .addCase(fetchActionPriorityCriticalRatio.rejected, (state, action) => {
        state.loading = false
        state.error = null
      })
      .addCase(fetchActionPriorityHighRatio.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchActionPriorityHighRatio.fulfilled, (state, action) => {
        state.high = action.payload
      })
      .addCase(fetchActionPriorityHighRatio.rejected, (state, action) => {
        state.loading = false
        state.error = null
      })
      .addCase(fetchActionPriorityMediumRatio.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchActionPriorityMediumRatio.fulfilled, (state, action) => {
        state.medium = action.payload
      })
      .addCase(fetchActionPriorityMediumRatio.rejected, (state, action) => {
        state.loading = false
        state.error = null
      })
      .addCase(fetchActionPriorityLowRatio.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchActionPriorityLowRatio.fulfilled, (state, action) => {
        state.low = action.payload
      })
      .addCase(fetchActionPriorityLowRatio.rejected, (state, action) => {
        state.loading = false
        state.error = null
      })
      .addCase(fetchCriticalActionsByMissionId.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchCriticalActionsByMissionId.fulfilled, (state, action) => {
        state.loading = false
        state.criticalActions = action.payload
      })
      .addCase(fetchCriticalActionsByMissionId.rejected, (state, action) => {
        state.loading = false
        state.error = null
      })
      .addCase(fetchHighActionsByMissionId.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchHighActionsByMissionId.fulfilled, (state, action) => {
        state.highActions = action.payload
      })
      .addCase(fetchHighActionsByMissionId.rejected, (state, action) => {
        state.loading = false
        state.error = null
      })
      .addCase(fetchMediumActionsByMissionId.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchMediumActionsByMissionId.fulfilled, (state, action) => {
        state.mediumAction = action.payload
      })
      .addCase(fetchMediumActionsByMissionId.rejected, (state, action) => {
        state.loading = false
        state.error = null
      })
      .addCase(fetchLowActionsByMissionId.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(fetchLowActionsByMissionId.fulfilled, (state, action) => {
        state.lowActions = action.payload
      })
      .addCase(fetchLowActionsByMissionId.rejected, (state, action) => {
        state.loading = false
        state.error = null
      })
  },
})

export default missionSlice.reducer
